import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconHotTub = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconHotTub",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M280-640q-33 0-56-23t-24-57 24-56 56-24 57 24 23 56-23 57-57 23M160-80q-33 0-56-23t-24-57v-280q0-17 12-28t28-12h80v-30q0-38 26-64t64-26q20 0 37 8t31 22l56 62 15 15 17 13h394q17 0 29 12t11 28v280q0 33-23 57t-57 23zm601-480q-16 0-26-11t-10-27q1-22-7-41t-24-35q-26-26-38-59t-14-68q0-16 11-27t26-12 27 12 10 27q-1 20 7 40t21 33q26 26 40 59t14 69q0 17-10 29t-27 11m-160 0q-16 0-26-11t-10-27q1-22-7-41t-24-35q-26-26-38-59t-14-68q0-16 11-27t26-12 27 11 9 27q-1 21 7 40t22 34q26 26 40 59t14 69q0 17-10 29t-27 11m79 400h80v-240h-80zm-160 0h80v-240h-80zm-160 0h80v-240h-80zm-160 0h80v-240h-80z"
  })
}));